(() => {
  if (window.utmb26Nav) {
    window.utmb26Nav.init(document);
    return;
  }

  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

  const getSections = (links) =>
    links
      .map((link) => {
        const id = link.dataset.utmb26NavTarget;
        if (!id) return null;
        const el = document.getElementById(id);
        return el ? { link, el, id } : null;
      })
      .filter(Boolean);

  const setup = (nav) => {
    if (nav.dataset.utmb26NavInitialized === "true") return;

    const track = nav.querySelector("[data-utmb26-nav-track]");
    const indicator = nav.querySelector("[data-utmb26-nav-indicator]");
    const links = [...nav.querySelectorAll("[data-utmb26-nav-link]")];
    const sections = getSections(links);

    if (!track || !indicator || !sections.length) return;

    let activeIndex = 0;
    let ticking = false;

    const moveIndicator = (index) => {
      const item = sections[index]?.link.closest(".utmb26-nav__item") || sections[index]?.link;
      if (!item) return;

      const trackRect = track.getBoundingClientRect();
      const itemRect = item.getBoundingClientRect();
      const width = itemRect.width;
      const left = itemRect.left - trackRect.left;

      indicator.style.width = `${width}px`;
      indicator.style.transform = `translateX(${left}px)`;
    };

    const setActive = (index) => {
      if (index < 0 || index >= sections.length) return;
      activeIndex = index;

      sections.forEach((section, i) => {
        section.link.classList.toggle("is-active", i === index);
        section.link.setAttribute("aria-current", i === index ? "true" : "false");
      });

      moveIndicator(index);
    };

    /**
     * Active while this section has entered the viewport threshold
     * and the next nav target has not entered yet.
     */
    const updateActiveFromScroll = () => {
      const threshold = nav.getBoundingClientRect().bottom + 1;
      let nextActive = 0;

      sections.forEach((section, index) => {
        if (section.el.getBoundingClientRect().top <= threshold) {
          nextActive = index;
        }
      });

      if (nextActive !== activeIndex) {
        setActive(nextActive);
      } else {
        moveIndicator(activeIndex);
      }
    };

    const onScrollOrResize = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        updateActiveFromScroll();
        ticking = false;
      });
    };

    const pushNavGa4 = (buttonName) => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event_parameters: null });
      window.dataLayer.push({
        event: "ga4Event",
        event_name: "select_content_category",
        event_parameters: {
          content_type: "navigation_bar",
          button_name: buttonName,
        },
      });
    };

    const scrollToSection = (index) => {
      const section = sections[index];
      if (!section) return;

      // Sticky nav sits below the site header; use its viewport bottom
      // so both header + utmb26-nav are cleared (matches updateActiveFromScroll).
      const offset = nav.getBoundingClientRect().bottom;
      const top = window.scrollY + section.el.getBoundingClientRect().top - offset + 1;

      window.scrollTo({
        top: Math.max(0, top),
        behavior: reduceMotion.matches ? "auto" : "smooth",
      });

      setActive(index);
    };

    links.forEach((link) => {
      link.addEventListener("click", (event) => {
        const targetIndex = sections.findIndex((section) => section.link === link);
        if (targetIndex < 0) return;
        event.preventDefault();
        pushNavGa4(link.textContent.trim());
        scrollToSection(targetIndex);
      });
    });

    window.addEventListener("scroll", onScrollOrResize, { passive: true });
    window.addEventListener("resize", onScrollOrResize);

    setActive(0);
    updateActiveFromScroll();

    nav.dataset.utmb26NavInitialized = "true";
  };

  const init = (root = document) => {
    if (root.matches?.("[data-utmb26-nav]")) {
      setup(root);
    }
    root.querySelectorAll?.("[data-utmb26-nav]").forEach(setup);
  };

  document.addEventListener("shopify:section:load", (event) => {
    init(event.target);
  });

  window.utmb26Nav = { init };
  init();
})();
